export const getLanguagesSpoken = (language) => {
  return language === '0' || !language ? '' : language;
};
